import { TypeModeleEvaluation } from 'src/app/constantes/evaluations/type-modele-evaluation';

export interface ProcessParametrageOption {
  libelle: string;
  valeur: number;
  statut?: number;
  typeObjet?: typeObjetEnum;
  typeDeclencheur?: typeDeclencheurEnum;
  estParcours?: boolean;
}

export class ProcessParametrage {
  periodes: ProcessParametrageOption[] = [];
  durees: ProcessParametrageOption[] = [];
  avantApres: ProcessParametrageOption[] = [];
  quand: ProcessParametrageOption[] = [];
  choix: ProcessParametrageOption[] = [];
  actions: ProcessParametrageOption[] = [];
}

export interface ProcessChampConditionDetails {
  operateurs: ProcessParametrageOption[];
  typeRetour?: number;
  valeurs: ProcessParametrageOption[];
}

export interface ProcessConditionRule {
  idChamp: number | null;
  operateurValeur: number | null;
  valeurChoisie: number | null;
  operateursOptions: ProcessParametrageOption[];
  valeursOptions: ProcessParametrageOption[];
  loadingChamp: boolean;
}

export interface ProcessConditions {
  operateurLibelle: string;
  operateurValeur: number;
  regles: ProcessConditionRule[];
}
export interface ProcessActionPayload {
  id: number | null;
  nom: string;
  typeAction: number;
  idModele: number;
  libelle?: string;
}

export interface ProcessDeclencheurPayload {
  id?: number;
  actif: boolean;
  quantite: number;
  libelle: number;
  durees: number;
  quand: number;
  avantApres: number;
  typeObjet: number;
  type: number;
  titre?: string;
  description?: string;
  typeDeclencheur: number;
  estParcours: boolean;
  typeTemporel: ProcessLibraryColonne;
}

export interface ProcessConditionReglePayload {
  idChamp: number;
  operateurLibelle: string;
  operateurValeur: number;
  valeursString: string[];
  valeursNumerique: number[];
  statut: number;
}

export interface ProcessConditionsPayload {
  operateurLibelle: string;
  operateurValeur: number;
  regles: ProcessConditionReglePayload[];
}

export interface ProcessEnregistrementPayload {
  declencheur: ProcessDeclencheurPayload;
  conditions: ProcessConditionsPayload;
  actions: ProcessActionPayload[];
}


export interface ProcessActionFormValue {
  id: number | null;
  cleLigne: string;
  typeAction: number | null;
  idModele: number | null;
  mailSujet?: string;
}

export interface ProcessMailModelSelection {
  id: number;
  nom: string;
}

export enum ProcessLibraryColonne {
  AvantSession = 1,
  PendantSession = 2,
  ApresSession = 3,
  BienApresEtAutres = 4,
}

export interface ProcessLibraryColonneConfig {
  id: ProcessLibraryColonne;
  titre: string;
  icon: string;
  cssClass: string;
}

/** Colonnes affichées sur la page des automatisations ; `BienApresEtAutres` n'est pas encore proposée. */
export const PROCESS_COLONNES: ProcessLibraryColonneConfig[] = [
  { id: ProcessLibraryColonne.AvantSession, titre: 'Avant la session', icon: 'icon-clock', cssClass: 'avant' },
  { id: ProcessLibraryColonne.PendantSession, titre: 'Pendant la session', icon: 'icon-user1', cssClass: 'pendant' },
  { id: ProcessLibraryColonne.ApresSession, titre: 'Après la session', icon: 'icon-chevron-right', cssClass: 'apres' },
];

export function isProcessColonneAffichee(value: unknown): value is ProcessLibraryColonne {
  return PROCESS_COLONNES.some((c) => c.id === value);
}

export interface ProcessForLibrary{
  id: number;
  titre: string;
  actif: boolean;
  nbConditions: number;
  nbActions: number;
  typeTemporel: ProcessLibraryColonne;
}

export enum typeObjetEnum {
  Session = 1,
  Seance = 2,
  Formation = 3,
  Inscription = 4,
  Contrat = 5,
}

export enum typeDeclencheurEnum {
  Temporel = 1,
  Enregistrement = 2,
  Modification = 3,
}

export interface ListeOptionsCondition {
  operateursOptions: ProcessParametrageOption[];
  valeursOptions: ProcessParametrageOption[];
  loadingChamp: boolean;
}

export interface ApercuPastilleCondition {
  texte: string;
  statut: number;
  /** Renseigné pour le champ « Catégorie d'évaluation » : prime sur le statut pour la couleur. */
  categorieEvaluation?: TypeModeleEvaluation;
}

export interface ApercuLigneCondition {
  libelle: string;
  /** Libellé de l'opérateur (« égal à », « différent de »…) ; vide quand il est déjà la pastille de valeur. */
  operateur: string;
  pastilles: ApercuPastilleCondition[];
  estMiseEnEvidence: boolean;
  type: number;
}

export interface ApercuLigneAction {
  typeLibelle: string;
  nomAffichage: string;
  nomEstIndicatif: boolean;
}
